import React from 'react';
import Modal from '../../../../shared/modal';
import Button from '../../../../shared/button';
import moment from 'moment';
import { INVOICES_STATUS } from '../../../../utils/constants/invoices-status';
import { capitalizeWords } from '../../../../utils/capitalizeText';


interface IAcitivityDetailsModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const AcitivityDetailsModal = ({
    openModal,
    data,
    handleCloseModal,
}: IAcitivityDetailsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }
    return (
        <Modal
            open={openModal}
            showInRight
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'
            onClose={onCloseModal}>
            <div className={'p-2 min-w-[95vw] md:min-w-[600px]'}>
                <p className='mb-4 font-semibold text-sm'>Details</p>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 my-9'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                        <div className='mb-4'>
                            <p className='font-bold'>Agent</p>
                            <p>{data?.agent === 'accounting_agent' ? 'Accounting Agent' : data?.agent}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Initiated</p>
                            <p>{moment(data?.startedAt)?.format('DD/MM/YYYY, h:mm:ss a')}</p>
                        </div>
                        {data?.completedAt &&
                            <div className='mb-4'>
                                <p className='font-bold'>Completed</p>
                                <p>{moment(data?.completedAt)?.format('DD/MM/YYYY, h:mm:ss a')}</p>
                            </div>
                        }
                        <div className='mb-4'>
                            <p className='font-bold'>Invoice Status</p>
                            <p>{data?.additionalInfo?.status ? INVOICES_STATUS?.find((item: any) => item?.value === data?.additionalInfo?.status)?.label || data?.additionalInfo?.status : ''}</p>
                        </div>
                        <div className='mb-4'>
                            <p className='font-bold'>Status</p>
                            <p>{capitalizeWords(data?.status || '')}</p>
                        </div>
                        {data?.additionalInfo?.invoiceNumber &&
                            <div className='mb-4'>
                                <p className='font-bold'>Invoice Number</p>
                                <p>{data?.additionalInfo?.invoiceNumber}</p>
                            </div>
                        }
                        {data?.additionalInfo?.clientInfo &&
                            <div className='mb-4'>
                                <p className='font-bold'>Customer Name</p>
                                <p>{data?.additionalInfo?.clientInfo?.name}</p>
                            </div>
                        }
                        {data?.additionalInfo?.clientInfo &&
                            <div className='mb-4'>
                                <p className='font-bold'>Customer Email</p>
                                <p>{data?.additionalInfo?.clientInfo?.email}</p>
                            </div>
                        }
                    </div>
                    <div className='mb-4'>
                        <p className='font-bold'>Description</p>
                        <p>{data?.task}</p>
                    </div>
                </div>
                <div className='min-w-[100%] flex flex-row justify-center'>
                    <Button
                        label={'Close'}
                        className={'btn-primary-rounded-less my-9 min-w-full !shadow-none'}
                        type='submit'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default AcitivityDetailsModal;